(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ya-guven-animasyon"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ya-trust-stats')) return;
  class YATrustStats extends HTMLElement {
    connectedCallback() {
      this.frames = [];
      this.setupFrame = requestAnimationFrame(() => this.setup());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      this.stop();
      this.observer?.disconnect();
      this.reduced?.removeEventListener('change', this.onReducedChange);
    }
    setup() {
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.items = [...this.querySelectorAll('.ya-trust-card')].map(card => {
        const raw = (card.dataset.value || '').trim();
        const value = Number(raw.replace(',', '.'));
        const kind = card.dataset.kind;
        const valid = /^\d+(?:[.,]\d+)?$/.test(raw) && Number.isFinite(value) && value >= 0
          && (kind !== 'rating' || value <= 5) && (kind !== 'percent' || value <= 100);
        const decimals = Math.min(2, Math.max(0, Number(card.dataset.decimals) || 0));
        return {card, value, valid, kind, node: card.querySelector('[data-counter]'), format: new Intl.NumberFormat('tr-TR', {minimumFractionDigits: decimals, maximumFractionDigits: decimals})};
      });
      this.onReducedChange = () => { if (this.reduced.matches) this.finish(); };
      this.reduced.addEventListener('change', this.onReducedChange);
      this.items.forEach(item => this.paint(item, 1));
      if (this.dataset.motion !== 'true' || this.reduced.matches || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.play(); }
      }, {threshold: 0.12});
      this.observer.observe(this);
    }
    stop() {
      (this.frames || []).forEach(cancelAnimationFrame);
      this.frames = [];
      (this.items || []).forEach(item => item.card.getAnimations?.().forEach(animation => animation.cancel()));
    }
    finish() {
      this.stop();
      this.observer?.disconnect();
      (this.items || []).forEach(item => this.paint(item, 1));
    }
    paint(item, progress) {
      if (!item.valid) {
        item.node.textContent = '—';
        item.card.style.setProperty('--ya-progress', '0%');
        return;
      }
      item.node.textContent = item.format.format(item.value * progress);
      const percent = item.kind === 'rating' ? item.value / 5 * 100 : item.value;
      item.card.style.setProperty('--ya-progress', `${Math.min(100, percent * progress)}%`);
    }
    play() {
      if (this.reduced.matches || !this.isConnected) return this.finish();
      this.stop();
      const duration = Math.max(400, Math.min(2500, Number(this.dataset.duration) || 1300));
      this.items.forEach((item, index) => {
        if (!item.valid) return;
        const start = performance.now() + index * 100;
        item.card.animate?.([{opacity: .2, transform: 'translateY(14px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 550, delay: index * 100, easing: 'ease-out', fill: 'backwards'});
        const tick = now => {
          const progress = Math.max(0, Math.min(1, (now - start) / duration));
          this.paint(item, 1 - Math.pow(1 - progress, 3));
          if (progress < 1) this.frames[index] = requestAnimationFrame(tick);
        };
        this.paint(item, 0);
        this.frames[index] = requestAnimationFrame(tick);
      });
    }
  }
  customElements.define('ya-trust-stats', YATrustStats);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ya-hizmet-kartlari"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ya-sales-cards')) return;
  class YASalesCards extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.onVariantChange.bind(this);
    }
    connectedCallback() { this.addEventListener('change', this.onVariantChange); }
    disconnectedCallback() { this.removeEventListener('change', this.onVariantChange); }
    onVariantChange(event) {
      const select = event.target;
      if (!select.matches('[data-ya-variant]')) return;
      const option = select.selectedOptions[0];
      const card = select.closest('.ya-offer-card');
      if (!option || !card) return;
      const price = card.querySelector('[data-ya-price]');
      const button = card.querySelector('[data-ya-buy]');
      const quantity = card.querySelector('[data-ya-quantity]');
      if (price) price.textContent = option.dataset.price || '';
      if (quantity) quantity.value = String(Math.max(1, Number(option.dataset.minimum) || 1));
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Tükendi' : button.dataset.label;
      }
    }
  }
  customElements.define('ya-sales-cards', YASalesCards);
})();

  } catch(e) { console.error(e); }
})();
})();
